import React from 'react';
import {useTranslation} from "react-i18next";

export const ErrorScreen = ({onRetry}) => {

    const {t} = useTranslation();

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
            <div className="text-center animate-fade-in">
                <div className="text-4xl mb-2">😵</div>
                <h2 className="text-xl font-bold text-gray-800 mb-2">{t('error.title')}</h2>
                <p className="text-gray-500 text-sm mb-6 max-w-[300px] mx-auto">
                    {t('error.subtitle')}
                </p>

                {onRetry && (
                    <button
                        onClick={onRetry}
                        className="px-6 py-3 bg-gray-900 text-white rounded-xl font-bold text-sm hover:bg-black transition-colors shadow-lg active:scale-95"
                    >
                        {t('error.retry_btn')}
                    </button>
                )}
            </div>
        </div>
    );
};